import { axiosInstancepy } from "./AxiosInstance";

export async function getProspectiveRAF(body) {
  return axiosInstancepy
    .post("/ProspectiveRaf/", body)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error;
    });
}
